import { Modal as MantineModal, ModalProps } from "@mantine/core";
import { ReactNode } from "react";
import GradientBorderRadius from "../gradient-border-radius";
import clsx from "clsx";

type ExtendedModalProps = ModalProps & {
  onlyChildren?: boolean;
};

export const Modal = ({
  children,
  className,
  onlyChildren = false,
  ...rest
}: ExtendedModalProps) => {
  return (
    <MantineModal
      trapFocus={false}
      {...rest}
      withCloseButton={false}
      padding={0}
      centered
      styles={{
        inner: { padding: 0 },
        content: { padding: 0 },
        header: { padding: 0 },
        body: { padding: 0 },
      }}
    >
      {onlyChildren ? (
        <div className="flex items-center justify-center text-white">
          {children}
        </div>
      ) : (
        <GradientBorderRadius>
          <div
            className={clsx(
              "flex flex-col p-2 pb-[0.9375rem] w-full h-full gap-[0.9375rem]",
              className
            )}
          >
            {children}
          </div>
        </GradientBorderRadius>
      )}
    </MantineModal>
  );
};

const Title = ({ title, className }: { title: string; className?: string }) => {
  return (
    <div
      className={clsx(
        "text-sm text-white w-full flex justify-center items-center",
        className
      )}
    >
      {title}
    </div>
  );
};

const Description = ({
  description,
  className,
}: {
  description: string;
  className?: string;
}) => {
  return (
    <div className={clsx("text-sm text-white w-full text-center", className)}>
      {description}
    </div>
  );
};

const ModalFooter = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={clsx(
        "flex flex-row gap-[0.3125rem] justify-center w-full",
        className
      )}
    >
      {children}
    </div>
  );
};

Modal.Title = Title;
Modal.Description = Description;
Modal.Footer = ModalFooter;
